<template>
    <a v-if="getBasketItemById" href="javascript:;" class="btn btn-black">
        {{toOrderTitle}}
    </a>
    <a v-on:click="addItemToBasket" v-else href="javascript:;" class="btn btn-std">
        {{ inBasketTitle}}
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';
    import _u from "jsAssets/utils/index";
    import FavoriteProduct from "vueComponents/product/favorite/FavoriteCatalogItem";

    /**
     * Компонент представляет собой отдельную кнопку для добавление товара в корзину
     * Если на этой же странице в хранилище не записывалось количество товаров необходимых для
     * добавление в корзину то будет додана только 1 единица товара с Id - product_id
     *
     * Для работы необходимо передать Id товара к которому относится компонент
     *
     * @vuedoc
     * @module vue:components/ProductDetailOrderBtn
     * @exports vue:components/ProductDetailOrderBtn
     */

    export default {
        name: "product-detail-order-btn",

        props: [
            'to_order_title','in_basket_title','product_id'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} inBasketTitle - Название кнопки когда товар в корзине
         * @property {string} toOrderTitle - Название кнопки когда товар отсутствует в корзине
         * @property {string|int} productId - Id товара
         *
         */
        data() {
            return {
                inBasketTitle: this.to_order_title,
                toOrderTitle: this.in_basket_title,
                productId: this.product_id,
            }
        },

        computed: {
            ...mapGetters('productQuantity', [
                'productQuantity',
            ]),

            ...mapGetters('basket', [
                'basketItems',
            ]),
            /**
             *  Вычисляемое свойство которое возвращает список товаров в корзине
             *
             * @method getBasketItems
             */
            getBasketItems() {
                if(typeof this.basketItems !== 'undefined') {
                    return this.basketItems;
                }
            },
            /**
             *  Вычисляемое свойство которое в зависемости от Id товара определяет его принадлежность
             *  к корзине
             *
             * @method getBasketItemById
             */
            getBasketItemById() {
                if(this.basketItems && this.basketItems[this.productId] !== 'undefined') {
                    return this.basketItems[this.productId];
                }
                return false;
            },
            /**
             *  Вычисляемое свойство которое определяет количество товаров которое хотят добавить в корзину,
             *  Информация поступает из store/models/productQuantity
             *
             * @method productQuantityProp
             */
            productQuantityProp: function () {
                if(this.productQuantity && this.productQuantity[this.productId] !== 'undefined') {
                    return this.productQuantity[this.productId];
                }
            }

        },

        mounted(){
        },

        methods: {
            /**
             *  При нажатии на кнопку идет запрос к серверу на добавление товара в корзину
             *
             * @method addItemToBasket
             */
            addItemToBasket(){
                this.$store.dispatch('basket/addItemToBasket',{productId: this.productId,quantity: this.productQuantityProp ? this.productQuantityProp: 1 });
            },
        }
    }


</script>
